import { useNavigate } from 'react-router-dom';
import { useAuthStore } from 'src/store/auth';

import type { LoginRequest } from 'src/services/interfaces/auth';

/**
 * @param onSuccess Overrides the default post-registration side effect (B2C
 * navigate to `/form`). The W2 employee flow passes its enroll step here so the
 * same branded registration screen is reused without leaving the token flow.
 */
export const useRegister = (onSuccess?: () => void) => {
  const { register: registerAction, clear, error, isLoading } = useAuthStore();
  const navigate = useNavigate();

  const handleRegister = async (credentials: LoginRequest) => {
    await registerAction(credentials);

    // If registration was successful, the token will be stored in localStorage
    if (localStorage.getItem('token')) {
      // W2 employee flow: hand off to the enroll step instead of the B2C nav.
      if (onSuccess) {
        onSuccess();
      } else {
        navigate('/form', { replace: true });
      }
    }
  };

  return { clear, register: handleRegister, error, isLoading };
};
